import {Injectable} from '@angular/core';
import {PhotovoltaikcheckBackendService} from './backend.service';
import {PortalService} from '../../services/portal.service';
import {Router} from "@angular/router";
import {PhotovoltaikcheckAnfrage} from "../anfrage/photovoltaikcheck.anfrage";
import {RequestService} from "../../services/request.service";
import {EmbedService} from "../../services/embed.service";
import {RequestAnfrage} from "../../model/request.anfrage";

/**
 * global advisordata that can be injected by the backend
 * @var object
 */
declare let advisorObjectData;

/**
 * Service for saving the request data locally in the browser to have it on all steps.
 */
@Injectable({
  providedIn: 'root'
})
export class PhotovoltaikcheckRequestService extends RequestService {

  /**
   * @inheritdoc
   */
  requestObjectName = 'pvc-anfrage';

  /**
   * constructor.
   */
  constructor(public backendService: PhotovoltaikcheckBackendService, private router: Router,
              protected portalService: PortalService, protected embedService: EmbedService) {
    super(backendService, portalService, embedService);

    try {
      if (typeof advisorObjectData === "object" && typeof localStorage === "object") {
        // save injected data
        localStorage.setItem(this.requestObjectName, JSON.stringify(advisorObjectData));

        // if we preset the data, redirect to result step
        this.router.navigate([this.portalService.currentPortalId + '/photovoltaikcheck/ergebnis']);
      }
    } catch (e) {

    }

    this.loadDataFromLocalStorage();
  }

  /**
   * @inheritdoc
   */
  getNewAnfrage(): RequestAnfrage {
    return new PhotovoltaikcheckAnfrage();
  }

  /**
   * @inheritdoc
   */
  getAnfrage(): PhotovoltaikcheckAnfrage {
    return super.getAnfrage() as PhotovoltaikcheckAnfrage;
  }
}
